require('./ctxTableTree.style.scss');

class CtxTableTreeController {
    constructor($scope, $element, $timeout, $q, ivhTreeviewMgr, ivhTreeviewBfs) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.ivhTreeviewMgr = ivhTreeviewMgr;
        this.ivhTreeviewBfs = ivhTreeviewBfs;
        this.filter = '';

        this.elements = this.elements || [
                {
                    label: 'C:/',
                    value: 'c',
                    children: [{
                        label: 'Working folder',
                        value: 'working_folder',
                        children: [{
                            label: 'Meeting.txt',
                            value: 'meeting.txt'
                        }, {
                            label: 'Important.iso',
                            value: 'Important.iso'
                        }]
                    }, {
                        label: 'Other',
                        value: 'Other'
                    }]
                },
                {
                    label: 'D:/',
                    value: 'd',
                    children: [{
                        label: 'File One.txt',
                        value: 'File One.txt'
                    }, {
                        label: 'File Two.txt',
                        value: 'File Two.txt'
                    }]
                }
            ];
    }

    $onInit() {
        this.deselectAll();
        this.useFilter = this.useFilter || false;
        this.labelAttribute = this.labelAttribute || 'label2';
        this.childrenAttribute = this.childrenAttribute || 'children';
        this.expandToDepth = this.expandToDepth || 0;
        this.twistieExpandedTpl = '<span class="icon-minus"></span>';
        this.twistieCollapsedTpl = '<span class="icon-add"></span>';
        this.twistieLeafTpl = '<span class="twistieLeafTpl"></span>';

        this.selectedElements = this.selectedElements || [];

        this.customOpts = {
            idAttribute: this.idAttribute,
            labelAttribute: this.labelAttribute,
            childrenAttribute: this.childrenAttribute,
            useCheckboxes: true,
            expandToDepth: this.expandToDepth,
            twistieExpandedTpl: this.twistieExpandedTpl,
            twistieCollapsedTpl: this.twistieCollapsedTpl,
            twistieLeafTpl: this.twistieLeafTpl,
            onToggle: this.onToggle.bind(this),
            onCbChange: this.onCbChange.bind(this)
        };

        this.treeTable = this.$element.find('#tree-table');
        this.$scope.$watch(() => this.treeTable.height(), () => {
            this.calculateLabelWidth();
        });
        this.insideHorizontal = this.$element.find('#inside-horizontal');
        this.horizontalTreeScroller = this.$element.find('#horizontal-tree-scroller');
        this.$scope.$watch(() => this.insideHorizontal.width(), () => {
            this.$element.find('#horizontal-tree-scroller').mCustomScrollbar("update");
        });
    }

    whileScrollingFn() {
        if(angular.isUndefined(this.scrollEl)) return;
        this.$element.find('.title-wrapper').scrollLeft(this.scrollEl.draggerLeft * 2.5);
    }

    calculateLabelWidth() {
        this.resetLabelWidth().then(() => {
            const maxWidth = this.getMaxLabelWidth();

            if(!this.showHorizontalFlas && this.$element.find('#horizontal-tree-scroller').width() < maxWidth) {
                this.showHorizontalFlas = true;
                this.$element.find('#horizontal-tree-scroller .mCustomScrollBox ~ .mCSB_scrollTools').css('opacity', 1);
            }
            else if(this.showHorizontalFlas && this.$element.find('#horizontal-tree-scroller').width() > maxWidth) {
                this.showHorizontalFlas = false;
                this.$element.find('#horizontal-tree-scroller .mCustomScrollBox ~ .mCSB_scrollTools').css('opacity', 0);
            }

            this.$element.find('.table-tree-checkbox label').css('min-width', maxWidth + 'px');
            this.insideHorizontal.css('min-width', maxWidth + 'px');
        });
    }

    resetLabelWidth() {
        let deferred = this.$q.defer();
        this.$element.find('.table-tree-checkbox label').css('min-width', '0px');
        this.insideHorizontal.css('min-width', '0px');
        deferred.resolve(this.getMaxLabelWidth());
        return deferred.promise;
    }

    getMaxLabelWidth() {
        this.titleLables = this.$element.find(".table-tree-checkbox label");
        let maxWidth = 0;
        let e = {};

        for (let i = 0; i < this.titleLables.length; i++) {
            e = angular.element(this.titleLables[i]);
            if (e.width() > maxWidth) {
                maxWidth = e.width();
            }
        }

        return maxWidth;
    }

    deselectAll() {
        this.ivhTreeviewMgr.deselectAll(this.elements);
    }

    selectElements() {
        this.selectedElements = [];
        let done = false;
        this.ivhTreeviewBfs(this.elements, node => {
            if (done) {
                return false;
            }
            if((this.isWindowsOs && (node.selected && node.parent && !node.parent.selected)) || (!this.isWindowsOs && (node.selected && node.parent))) {
                !_.some(this.selectedElements, node) ? this.selectedElements.push(node) : _.remove(this.selectedElements, () => node);
            }
            return !done;
        });
    }

    onToggle(node) {
        this.toggledNode = node;
        /*if (!node.ivhIsExpanded) {
            node.ivhNode.children = [new FileItem()];
        }*/
        this.$timeout(() => {
            this.onToggleCallback();
        }, 0);
    }

    onCbChange(node) {
        this.cbChangedNode = node;
        this.selectElements();
        this.$timeout(() => {
            this.onCbChangeCallback();
        }, 0);
    }
}

const ctxTableTreeComponent = {
    controller: CtxTableTreeController,
    controllerAs: 'ctxTableTree',
    require: ['ngModel'],
    scope: {},
    template: require('./ctxTableTree.template.html'),
    bindings: {
        selectedElements: '=?ngModel',
        useFilter: '<?',
        elements: '=?',
        toggledNode: '=?',
        onToggleCallback: '&?',
        cbChangedNode: '=?',
        onCbChangeCallback: '&?',
        idAttribute: '@?',
        labelAttribute: '@?',
        childrenAttribute: '@?',
        expandToDepth: '<?',
        isWindowsOs: '<?'
    }
};

CtxTableTreeController.$inject = ['$scope', '$element', '$timeout', '$q', 'ivhTreeviewMgr', 'ivhTreeviewBfs'];

module.exports = ctxTableTreeComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/ctxTableTree.component.js